<template>
    <b-card class="shadow" style="min-height: 700px" ref="printMe">
        <div class="row">
            <div class="col-12 px-0">
                <div
                    class="d-flex align-items-center justify-content-between mb-1"
                >
                    <div class="col-md-4">
                        <h5 class="mb-0 text-gray-800">
                            {{ $t("Gráficos de Atendimentos") }}
                        </h5>
                    </div>
                    <div class="col-md-8 " :class="tabAtiva != 'Atendimentos Por Período' ?'d-flex justify-content-end' :''">
                        <b-button-group>
                            <b-button
                                variant="outline-dark"
                                :class="
                                    viewFilterReport === true ? 'active' : ''
                                "
                                @click="viewFilters"
                                v-if="tabAtiva != 'Atendimentos Por Período'"
                            >
                                <i class="fas fa-filter"></i>
                                {{ $t("Filtros") }}
                            </b-button>
                        </b-button-group>
                        <template
                            v-if="tabAtiva === 'Atendimentos Por Período'"
                        >
                            <div class="row">
                                <form-select
                                    grid="6"
                                    label="Ano"
                                    :itens="years"
                                    v-model="filtroYear"
                                    @change="getAnalytics()"
                                />

                                <form-select
                                    grid="6"
                                    label="Mês"
                                    :itens="months"
                                    v-model="filtroMonth"
                                    placeholder="Selecione um mês"
                                    @change="getAnalytics()"
                                />
                            </div>
                        </template>
                    </div>
                </div>
            </div>

            <!-- <filter-reports
        :report.sync="report"
        @loadlist="getAnalytics"
        :showFilterReport="viewFilterReport"
        @hideFilter="viewFilters"
      ></filter-reports> -->

            <div class="col-md-12 px-0">
                <div class="col-12">
                    <p>
                        Período de pesquisa selecionado:
                        <b>{{ report.datas.start }} - {{ report.datas.end }}</b>
                        <b-link
                            href="#"
                            @click.prevent="void 0"
                            class="mb-2"
                            variant="info"
                            v-b-popover.hover.top="
                                'Através do botão filtros você pode selecionar um intervalo de datas para impressão de seus dados.'
                            "
                        >
                            <i class="fas fa-info-circle"></i>
                        </b-link>
                    </p>
                </div>
                <div class="col-12 no-print" v-if="viewFilterReport">
                    <!-- Filtros -->
                    <form @submit.prevent="getAnalytics" ref="addItem">
                        <div class="row">
                            <form-calendar
                                v-model="data_inicio"
                                grid="6"
                                label="Data Inicial"
                                :max-date="dataNow"
                            />

                            <form-calendar
                                v-model="data_fim"
                                grid="6"
                                label="Data final"
                                :required="verificaDataInicial"
                                :min-date="data_inicio"
                                :max-date="dataNow"
                            />
                        </div>
                        <div
                            class="row pt-4 mb-4 px-0 d-flex justify-content-end"
                        >
                            <div class="col-auto px-2 text-right">
                                <button
                                    class="btn btn-default"
                                    @click="viewFilters"
                                >
                                    <i class="fas fa-times"></i>
                                </button>

                                <button
                                    type="button"
                                    class="btn btn-secondary"
                                    @click.prevent="limparFiltros()"
                                >
                                    {{ $t("Limpar Filtros") }}
                                </button>

                                <button
                                    class="btn btn-success btn-submit"
                                    data-style="zoom-in"
                                    type="submit"
                                >
                                    <i class="fas fa-chart-bar"></i>
                                    {{ $t("Gerar Relatório") }}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            <div class="col-12" id="boxPrint">
                <b-tabs content-class="mt-3">
                    <b-tab
                        title="Período"
                        active
                        @click.prevent="changeTab('Atendimentos Por Período')"
                    >
                        <div
                            class="col-md-12"
                            v-if="tabAtiva == 'Atendimentos Por Período'"
                        >
                            <loading-animation
                                :active.sync="loading"
                                :is-full-page="false"
                                :opacity="1"
                                color="#5895FF"
                            />

                            <span v-if="report.listatendimentos.length == 0">
                                <div
                                    class="row align-items-center text-center empty-graph"
                                >
                                    <div class="col">
                                        <img
                                            :alt="$t('No results')"
                                            class="mb-3"
                                            src="/img/graphics/statistic_chart.svg"
                                            style="max-height: 100px"
                                        />
                                        <h5>
                                            {{ $t("No records available") }}
                                        </h5>
                                    </div>
                                </div>
                            </span>
                            <area-graph
                                v-else
                                :loading="loading"
                                :data="report.listatendimentos"
                                titulo="Atendimentos Por Período"
                                :range="range"
                                sizearea="300px"
                                sizecard="375px"
                            />
                        </div>
                        <div class="col-md-12">
                            <p class="text-muted small pb-1 mb-1">
                                Total de
                                <b v-if="report.total_lista_atendimentos"
                                    >({{ report.total_lista_atendimentos }})
                                </b>
                                {{ tabAtiva }}
                            </p>
                        </div>
                    </b-tab>
                    <b-tab
                        title="Tipo"
                        @click.prevent="changeTab('Atendimentos Por Tipo')"
                    >
                        <div class="row">
                            <div
                                class="col-md-12"
                                v-if="tabAtiva == 'Atendimentos Por Tipo'"
                            >
                                <loading-animation
                                    :active.sync="loading"
                                    :is-full-page="false"
                                    :opacity="1"
                                    color="#5895FF"
                                />

                                <span
                                    v-if="report.tipos_atendimentos.length == 0"
                                >
                                    <div
                                        class="row align-items-center text-center empty-graph"
                                    >
                                        <div class="col">
                                            <img
                                                :alt="$t('No results')"
                                                class="mb-3"
                                                src="/img/graphics/statistic_chart.svg"
                                                style="max-height: 100px"
                                            />
                                            <h5>
                                                {{ $t("No records available") }}
                                            </h5>
                                        </div>
                                    </div>
                                </span>
                                <column-chart
                                    v-else
                                    :data="report.tipos_atendimentos"
                                    height="500px"
                                ></column-chart>
                            </div>
                        </div>
                    </b-tab>

                    <b-tab
                        title="Unidades"
                        @click.prevent="changeTab('Atendimentos Por Unidades')"
                    >
                        <div class="row">
                            <div
                                class="col-md-12"
                                v-if="tabAtiva == 'Atendimentos Por Unidades'"
                            >
                                <loading-animation
                                    :active.sync="loading"
                                    :is-full-page="false"
                                    :opacity="1"
                                    color="#5895FF"
                                />

                                <span
                                    v-if="
                                        report.unidades_atendimentos.length == 0
                                    "
                                >
                                    <div
                                        class="row align-items-center text-center empty-graph"
                                    >
                                        <div class="col">
                                            <img
                                                :alt="$t('No results')"
                                                class="mb-3"
                                                src="/img/graphics/statistic_chart.svg"
                                                style="max-height: 100px"
                                            />
                                            <h5>
                                                {{ $t("No records available") }}
                                            </h5>
                                        </div>
                                    </div>
                                </span>
                                <pie-chart
                                    v-else
                                    :donut="true"
                                    :data="report.unidades_atendimentos"
                                    height="600px"
                                    legend="right"
                                ></pie-chart>
                            </div>
                        </div>
                    </b-tab>
                    <b-tab
                        title="Status"
                        @click.prevent="changeTab('Atendimentos Por Status')"
                    >
                        <div class="row">
                            <div
                                class="col-md-12"
                                v-if="tabAtiva == 'Atendimentos Por Status'"
                            >
                                <loading-animation
                                    :active.sync="loading"
                                    :is-full-page="false"
                                    :opacity="1"
                                    color="#5895FF"
                                />

                                <span
                                    v-if="report.tipos_atendimentos.length == 0"
                                >
                                    <div
                                        class="row align-items-center text-center empty-graph"
                                    >
                                        <div class="col">
                                            <img
                                                :alt="$t('No results')"
                                                class="mb-3"
                                                src="/img/graphics/statistic_chart.svg"
                                                style="max-height: 100px"
                                            />
                                            <h5>
                                                {{ $t("No records available") }}
                                            </h5>
                                        </div>
                                    </div>
                                </span>
                                <pie-chart
                                    v-else
                                    :donut="true"
                                    :data="report.tipos_atendimentos"
                                    height="600px"
                                ></pie-chart>
                            </div>
                        </div>
                    </b-tab>
                    <b-tab
                        title="Tipo por Status"
                        @click.prevent="
                            changeTab('Atendimentos Por Status e Tipo')
                        "
                    >
                        <div class="row">
                            <loading-animation
                                :active.sync="loading"
                                :is-full-page="false"
                                :opacity="1"
                                color="#5895FF"
                            />
                            <div
                                class="col-md-12"
                                v-if="
                                    tabAtiva ==
                                        'Atendimentos Por Status e Tipo' &&
                                    !loading
                                "
                            >
                                <span v-if="!report.status_atendimentos">
                                    <div
                                        class="row align-items-center text-center empty-graph"
                                    >
                                        <div class="col">
                                            <img
                                                :alt="$t('No results')"
                                                class="mb-3"
                                                src="/img/graphics/statistic_chart.svg"
                                                style="max-height: 100px"
                                            />
                                            <h5>
                                                {{ $t("No records available") }}
                                            </h5>
                                        </div>
                                    </div>
                                </span>
                                <div class="row">
                                  <form-select label="Selecione o status" v-model="status_select" :itens="report.status_itens" @change="changeGraficoTipo"/>
                                    <!-- <pie-chart
                                        :donut="true"
                                        :data="report.status_atendimentos"
                                        class="col-12 mb-3"
                                        legend="left"
                                        title="Gráfico de Status"
                                        :download="true"
                                    ></pie-chart> -->
                            
                                    <pie-chart
                                        :donut="true"
                                        :data="set_tipos_atendimentos"
                                        :labels="set_tipos_atendimentos"
                                        class="col-12"
                                        legend="right"
                                        title="Gráfico de tipos Por Status"
                                        height="600px"
                                        download="Gráfico de tipos Por Status"
                                       
                                    ></pie-chart>
                                </div>
                            </div>
                        </div>
                    </b-tab> 
                    <b-tab
                        title="Unidade por Status"
                        @click.prevent="
                            changeTab('Atendimentos Por Status e Unidade')
                        "
                    >
                        <div class="row">
                            <loading-animation
                                :active.sync="loading"
                                :is-full-page="false"
                                :opacity="1"
                                color="#5895FF"
                            />
                            <div
                                class="col-md-12"
                                v-if="
                                    tabAtiva ==
                                        'Atendimentos Por Status e Unidade' &&
                                    !loading
                                "
                            >
                                <span v-if="!report.status_atendimentos">
                                    <div
                                        class="row align-items-center text-center empty-graph"
                                    >
                                        <div class="col">
                                            <img
                                                :alt="$t('No results')"
                                                class="mb-3"
                                                src="/img/graphics/statistic_chart.svg"
                                                style="max-height: 100px"
                                            />
                                            <h5>
                                                {{ $t("No records available") }}
                                            </h5>
                                        </div>
                                    </div>
                                </span>
                                <div class="row">
                                  <form-select label="Selecione o status" v-model="status_select" :itens="report.status_itens" @change="changeGraficoTipo"/>
                                    <!-- <pie-chart
                                        :donut="true"
                                        :data="report.status_atendimentos"
                                        class="col-12 mb-3"
                                        legend="left"
                                        title="Gráfico de Status"
                                        :download="true"
                                    ></pie-chart> -->
                            
                                    <pie-chart
                                        :donut="true"
                                        :data="set_tipos_atendimentos"
                                        :labels="set_tipos_atendimentos"
                                        class="col-12"
                                        legend="right"
                                        title="Gráfico de Unidades Por Status"
                                        height="600px"
                                        download="Gráfico de Unidades Por Status"
                                       
                                    ></pie-chart>
                                </div>
                            </div>
                        </div>
                    </b-tab>
                </b-tabs>
            </div>
            <div class="col-md-12 text-center" v-if="!loading">
                <b-button
                    :title="$t('Imprimir')"
                    class="py-2"
                    size="sm"
                    type="button"
                    v-b-tooltip.hover
                    variant="primary"
                    @click="printHtml()"
                >
                    <i class="fas fa-print"></i>
                </b-button>
            </div>
        </div>
    </b-card>
</template>

<script>
import { GChart } from "vue-google-charts";
export default {
    name: "AtendimentosGraficos",
    components: {
        GChart,
    },
    data() {
        return {
            loading: true,
            loadingSearchUnidade: true,
            desabledSearchUnidade: true,
            loadingSearchTecnicos: true,
            loadingSearchTipos: true,
            range: "yearly",
            report: {
                listatendimentos: [],
                total_lista_atendimentos: 0,
                tipos_atendimentos: [],
                unidades_atendimentos: [],
                datas: {
                    start: "",
                    end: "",
                },
            },
            years: [],
            months: [],
            filtros: {},
            tabAtiva: "Atendimentos Por Período",
            filtroYear: moment().format("YYYY"),
            filtroMonth: null,
            status_select:"ABERTO",
            set_tipos_atendimentos: [],
            status:[],
      
        };
    },
    mounted() {
        this.getAnalytics();
    },
    methods: {
      changeGraficoTipo(){
        this.set_tipos_atendimentos = this.report.tipos_status[this.status_select];
      },
        
        changeTab(value) {
            if (value) {
                this.tabAtiva = value;
            } else {
                this.tabAtiva = "Atendimentos Por Período";
            }
            this.getAnalytics();
        },
        updateAnalytics(range) {
            if (this.range !== range) {
                this.range = range;
                this.getAnalytics();
            }
        },
        getAnalytics() {
            if (this.data_inicio) {
                this.filtros.data_inicial = this.$options.filters.formatDateYMD(
                    this.data_inicio
                );
            }
            if (this.data_fim) {
                this.filtros.data_final = this.$options.filters.formatDateYMD(
                    this.data_fim
                );
            }

            if (this.filtroMonth) {
                this.range = "monthly";
            } else {
                this.range = "yearly";
            }

            this.loading = true;
            const tab = { tab: this.tabAtiva };
            axios
                .get("api/dashboard/report/atendimentos/graficos", {
                    params: {
                        range: this.range,
                        filtros: this.filtros,
                        ...tab,
                        filtroYear: this.filtroYear,
                        filtroMonth: this.filtroMonth,
                    },
                })
                .then((response) => {
                    this.loading = false;
                    this.report = response.data.data;
                    this.years = response.data.data.years;
                    this.months = response.data.data.months;
                    if(this.report.tipos_atendimentos)
                    {
                      this.set_tipos_atendimentos = this.report.tipos_status['ABERTO'];
                    }
                    this.status_select = "ABERTO";
                })
                .catch(() => {
                    this.loading = false;
                });
        },
    },
};
</script>

<style scoped>
.btn-group .btn {
    padding: 6px 14px !important;
    margin-right: 0px;
}
</style>
